class BannerSlideshow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-banner-slideshow-track]');
    this.slides = Array.from(this.querySelectorAll('[data-banner-slideshow-slide]'));
    this.previousButton = this.querySelector('[data-banner-slideshow-previous]');
    this.nextButton = this.querySelector('[data-banner-slideshow-next]');
    this.dots = Array.from(this.querySelectorAll('[data-banner-slideshow-dot]'));
    this.autoplayDelay = Number(this.dataset.autoplayDelay) * 1000;
    this.isAutoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
    this.currentIndex = 0;

    if (!this.track || this.slides.length === 0) return;

    this.onScroll = this.update.bind(this);
    this.onMouseEnter = this.pause.bind(this);
    this.onMouseLeave = this.play.bind(this);
    this.onFocusIn = this.pause.bind(this);
    this.onFocusOut = this.play.bind(this);

    this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
    this.track.addEventListener('scroll', this.onScroll);
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);

    this.update();
    this.play();
  }

  disconnectedCallback() {
    this.pause();
    this.track?.removeEventListener('scroll', this.onScroll);
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('focusout', this.onFocusOut);
  }

  getSlideWidth() {
    return this.slides[0]?.getBoundingClientRect().width || 1;
  }

  update() {
    this.currentIndex = Math.round(this.track.scrollLeft / this.getSlideWidth());
    this.currentIndex = Math.max(0, Math.min(this.currentIndex, this.slides.length - 1));

    this.slides.forEach((slide, index) => {
      const isActive = index === this.currentIndex;
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.querySelectorAll('a').forEach((link) => {
        if (isActive) {
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('tabindex', '-1');
        }
      });
    });

    this.dots.forEach((dot, index) => {
      dot.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
    });
  }

  goTo(index) {
    const nextIndex = (index + this.slides.length) % this.slides.length;
    this.track.scrollTo({
      left: this.getSlideWidth() * nextIndex,
      behavior: 'smooth',
    });
  }

  play() {
    if (!this.isAutoplayEnabled || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.pause();
    this.autoplayTimer = window.setInterval(() => this.goTo(this.currentIndex + 1), this.autoplayDelay);
    this.track.setAttribute('aria-live', 'off');
  }

  pause() {
    window.clearInterval(this.autoplayTimer);
    this.track?.setAttribute('aria-live', 'polite');
  }
}

if (!customElements.get('banner-slideshow')) {
  customElements.define('banner-slideshow', BannerSlideshow);
}
